import type { StatValue } from "@/types/dashboard";
import { formatAmount, formatNumber } from "@/utils/formatters";

export function formatStat(stat: StatValue): string {
  if (stat.kind === "currency") return formatAmount(Number(stat.value) || 0);
  if (stat.kind === "number") return formatNumber(Number(stat.value) || 0);
  if (stat.kind === "percent") return `${Number(stat.value) || 0}%`;
  return String(stat.value ?? "—");
}
